<div class="subBlockContainer">
    <div class="subBlockContent" id="upgradeSubscription">
      <child-header [title]="title" (closeEvent)="close()"></child-header>
      <div class="child-body">
        <div class="inner-subBlock-wrapper">
          <div class="col-md-12">
            <form [formGroup]="form">

                <mat-accordion>
                  <!-- BRANDING-->
                  <mat-expansion-panel class="mt-3">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        BRANDING
                      </mat-panel-title>
                    </mat-expansion-panel-header>
          
                    <!-- color picker-->
                    <div class="row no-gutters">
          
          
                      <div class="title bradning-title col-md-12 my-3">Select Site Color</div>
          
          
                      <input id="color-picker" [style.background]="color" [cpPosition]="'bottom'" [cpCancelButton]="true" [cpOKButton]="true"
                            [cpCancelButtonClass]="'btn-primary btn btn-xs cancel-btn'" [cpOKButtonClass]="'btn-primary btn btn-xs'" [cpPositionRelativeToArrow]="true"
                            [(colorPicker)]="color">
          
                      <div class="title bradning-title col-md-12 my-3">{{color}}</div>
          
                    </div>
          
                    <!-- image dropbox-->
                    <div class="row  no-gutters">
          
                      <div class="title bradning-title col-md-12 mb-3">Upload Company Logo <span
                        class="basic-icon information-icon" placement="right"
                        ngbTooltip="Image size will be resized to 400 width, 100 height"></span></div>
          
                      <div class="custom-dropzone" [multiple]="false" [maxFileSize]="1000000" ngx-dropzone
                          [accept]="'image/*'" (change)="onSelect($event)">
                        <ngx-dropzone-label>
                          <div>
                            <h2>Drop Here</h2>
                          </div>
                        </ngx-dropzone-label>
                        <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" class="dropzone-image-preview"
                                                    *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                          <!-- <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label> -->
                        </ngx-dropzone-image-preview>
                      </div>
                    </div>
          
                    <div class="row  no-gutters mt-3">
                      <div class="slide-toggle" style="margin:auto">
                        <button (click)="deleteImage()" [disabled]="!uploadFile"
                                class="button button-red button-large">Delete
                          Company
                          Logo
                        </button>
                      </div>
                    </div>
          
                  </mat-expansion-panel>
          
                  <!-- PREFERENCES-->
                  <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                          <mat-panel-title>
                              PREFERENCES
                          </mat-panel-title>
                      </mat-expansion-panel-header>
          
                      <div formGroupName="preferences">
                          <!-- manage option -->
                          <div class="row  no-gutters">
                            <div class="title bradning-title col-md-12">Management Options</div>

                            <div class="title bradning-title col-md-6">
                              <div class class="title bradning-title col-md-12" style="padding-right: 175px; margin-left: 25px; padding-left: 0;">
                              <mat-form-field [floatLabel]="'always'">
                                <mat-select class="managementOption" formControlName="managementOption" required>
                                  <mat-option value="create">
                                    Create
                                  </mat-option>
                                  <mat-option value="manage">
                                    Manage
                                  </mat-option>
                                  <mat-option value="view_only">
                                    View Only
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              </div>
                            </div> 
                            <div class="title bradning-title col-md-6" *ngIf="form.get('preferences.managementOption')?.value === 'create'">
                              <mat-slide-toggle formControlName="CancelSubscriptionAllowed" (change)="onAllowCancel($event)">
                                Allow Cancel
                              </mat-slide-toggle>
                            </div>
                          </div>                
                          <!-- pricing option-->
                          <div class="row  no-gutters">
                            <div class="title bradning-title col-md-12">Pricing Options</div>
                          
                            <div class="title bradning-title col-md-12" style="padding-right: 625px; margin-left: 25px;">
                              <mat-form-field [floatLabel]="'always'">
                                <mat-select class="pricingOption" formControlName="pricingOption" required>
                                  <mat-option value="rrp_only">
                                    RRP Only
                                  </mat-option>
                                  <mat-option value="hide_pricing">
                                    Hide Pricing
                                  </mat-option>
                                  <mat-option value="custom_pricing">
                                    Custom Pricing
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>

                          <div *ngIf="form.get('preferences.pricingOption')?.value == 'custom_pricing'" class="col-md-12" style="margin-left: 25px;">
                            <div class="upload-content">
                              <p>
                                <b>GUIDELINES:</b>
                                <a class="download-sample" (click)="downloadSampleFile()"> Download </a>a sample file to create custom pricing for upload. Any custom pricing uploads will overwrite existing custom pricing.
                              </p>
                              <label>
                                <b class="dd-bond">
                                  Select a File to Upload:
                                </b>
                              </label>
                              <label id="drag-box" (drop)="drop($event)" (dragover)="allowDrop($event)">
                                Choose File or Drag And Drop<input type='file' class="file-display"
                                  (change)="onSelectFile($event)">
                              </label>
                              <button class="button button-red button-round"
                                style="margin-left: 5px;" (click)="downloadCurrentCustomPricing()">
                                &nbsp;Download Current Custom Pricing&nbsp;
                              </button>
                            </div>
           
                            <div>
                              <p *ngIf="fileName">
                                <b class="dd-bond">
                                  {{ fileName }}
                                </b>
                              </p>

                              <button *ngIf="fileName" class="button button-red button-round" (click)="preview()"
                                [disabled]="previewResult?.length || preivewLoading">
                                &nbsp;Preview&nbsp;
                              </button>

                            </div>
                            <mat-spinner style="margin: auto;" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"
                              diameter="20" *ngIf="preivewLoading">
                            </mat-spinner>
                          </div>
                          <div class="my-4" *ngIf="showCustomPricingPreviewTable()">
                            <div style="overflow-y: auto; margin-left: 40px;">
                              <table mat-table [dataSource]="previewResult">
                                <ng-container matColumnDef="tenantId">
                                  <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                                    class="table-column">TENANT GUID</th>
                                  <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                                    class="tb-row" style="white-space: pre;">{{ element.tenantGUID }}</td>
                                </ng-container>
                                <ng-container matColumnDef="stockCode">
                                  <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="table-column">
                                    STOCK CODE</th>
                                  <td class="align-left" mat-cell *matCellDef="let element" width="33%" class="tb-row"
                                    style="white-space: pre-line;">{{ element.stockCode }}</td>
                                </ng-container>
                                <ng-container matColumnDef="price">
                                  <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                                    class="table-column">PRICE</th>
                                  <td class="align-right" mat-cell *matCellDef="let element" width="33%" class="align-left"
                                    class="tb-row" style="white-space: pre;">{{ element.price }}</td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="previewColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: previewColumns ;let index = index;">
                                </tr>
                              </table>
                            </div>
                          </div>
              
                          <!-- Notification Email-->
                          <div class="row  no-gutters">
                  
                              <div class="title bradning-title col-md-12 mt-3">
                                Enter an email address below if you wish to receive change notifications
                              </div>
                  
                              <mat-form-field [floatLabel]="'always'" style="margin-left:40px;margin-right:20px">
                                <input matInput formControlName="notificationEmail">
                              </mat-form-field>
                  
                          </div>
                      </div>
          
                  </mat-expansion-panel>
          
                  <!-- CONTACT US-->
                  <mat-expansion-panel>
          
                    <p>The below contact details will be displayed to your customers on the Contact Us page of the portal</p>
          
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        CONTACT DETAILS
                      </mat-panel-title>
                    </mat-expansion-panel-header>
          
                    <div class="row  no-gutters" formGroupName="contactDetails" style="padding-left: 40px">
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="Company Name" formControlName="companyName">
                        </mat-form-field>
          
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="Address Line 1" formControlName="address1">
                        </mat-form-field>
          
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="Address Line 2" formControlName="address2">
                        </mat-form-field>
          
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="Suburb" formControlName="suburb">
                        </mat-form-field>
          
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="State" formControlName="state">
                        </mat-form-field>
          
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="Post Code" formControlName="postcode">
                          <mat-error *ngIf="form.get('contactDetails.postcode')?.invalid">Post Code is not valid</mat-error>
                        </mat-form-field>
          
                        <mat-form-field [floatLabel]="'always'">
                          <input matInput placeholder="Contact Email" formControlName="contactEmail">
                          <mat-error *ngIf="form.get('contactDetails.contactEmail')?.invalid">Contact Email is not valid</mat-error>
          
                        </mat-form-field>
          
                        <mat-form-field class="mt-2" [floatLabel]="'always'">
                          <input matInput placeholder="Contact Phone" formControlName="contactPhone">
                          <mat-error *ngIf="form.get('contactDetails.contactPhone')?.invalid">Contact Phone is not valid</mat-error>
                        </mat-form-field>
          
                      </div>
                  </mat-expansion-panel>
          
                  <div class="row  no-gutters mb-5">
                    <div class="slide-toggle" style="margin:auto">
                      <button id="updateBandingBtn" class="button button-red button-large"
                        (click)="updateTenantBranding()">Update Tenant Branding
                      </button>
                    </div>
                  </div>
                </mat-accordion>

            </form>
          </div>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
  